// extracted by mini-css-extract-plugin
module.exports = {"head":"ChangeAllowanceDisplayOrder__head--exknX","filter":"ChangeAllowanceDisplayOrder__filter--11MSu","dragging":"ChangeAllowanceDisplayOrder__dragging--1I9NP"};